import { useLingui } from '@lingui/react/macro';

import { MobileEntityFilter } from '@/components/SharedFilters/EntityFilter/MobileEntityFilter';
import IconPackage from '@/icons/Package.svg';

import { useFilters } from '../FiltersState';

export const FiltersStockLocation = () => {
  const { t } = useLingui();

  const {
    stockLocations: { stockLocations, setStockLocations },
  } = useFilters();

  return (
    <MobileEntityFilter
      filterId="stock-location"
      selectedEntities={stockLocations}
      setSelectedEntities={setStockLocations}
      includeGroups={false}
      traits={['stockLocation']}
      label={t({ id: 'requests.filters.stock-location.label', message: 'Stock location' })}
      searchPlaceholder={t({
        id: 'requests.filters.stock-location.search.label',
        message: 'Search stock locations',
      })}
      icon={<IconPackage />}
    />
  );
};
